import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-4 mb-10" }
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = { class: "d-flex flex-column fv-row" }
const _hoisted_7 = {
  class: "d-flex align-items-baseline mb-5",
  style: {"direction":"rtl !important"}
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "mw-125px d-flex align-items-center" }
const _hoisted_10 = {
  class: "w-100 d-flex justify-content-between",
  style: {"direction":"ltr !important"}
}
const _hoisted_11 = { class: "symbol symbol-25px me-1" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "text-gray-700" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "symbol symbol-35px me-1" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "fv-row mb-10" }
const _hoisted_18 = { class: "form-label fw-bolder text-gray-900 fs-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-control form-control-solid",
  type: "password",
  placeholder: "********",
  name: "password",
  autocomplete: "off",
  min: "8"
}, null, -1)
const _hoisted_20 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_21 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder me-4"
}
const _hoisted_22 = { class: "indicator-label" }
const _hoisted_23 = { class: "indicator-progress" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_25 = { class: "fv-row mb-10" }
const _hoisted_26 = { class: "text-center mb-10" }
const _hoisted_27 = { class: "text-muted fw-semibold fs-5 mb-5" }
const _hoisted_28 = {
  class: "fw-bold text-dark fs-3",
  style: {"direction":"ltr"}
}
const _hoisted_29 = { class: "mb-10" }
const _hoisted_30 = { class: "fw-bold text-center text-dark fs-6 mb-1 ms-1" }
const _hoisted_31 = { class: "d-flex flex-wrap flex-row-reverse flex-stack justify-content-center" }
const _hoisted_32 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_33 = {
  type: "submit_2",
  ref: "submitButton_2",
  id: "kt_password_reset_submit_2",
  class: "btn btn-lg btn-primary fw-bolder me-4"
}
const _hoisted_34 = { class: "indicator-label" }
const _hoisted_35 = { class: "indicator-progress" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_SendActivationCode = _resolveComponent("SendActivationCode")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.translate("Forgot Password ?")), 1)
    ]),
    (_ctx.resetStep === 1)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
          onSubmit: _ctx.onSubmitForgotPassword,
          id: "kt_login_password_reset_form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.translate("Enter your phone number to reset your password")) + ". ", 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    style: {"margin-left":"1rem"},
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                    class: "form-control",
                    name: "mobile",
                    placeholder: _ctx.translate('mobile')
                  }, null, 8, _hoisted_8), [
                    [_vModelText, _ctx.formData.mobile]
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_select, {
                      class: "bg-transparent",
                      placeholder: _ctx.translate('Select country'),
                      modelValue: _ctx.selectedLan,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLan) = $event)),
                      name: "country_code",
                      dir: "ltr"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: _ctx.selectedLan?.phone_code,
                            value: item,
                            selected: index === 1
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, [
                                  _createElementVNode("img", {
                                    class: "rounded-1",
                                    src: `https://flagcdn.com/w40/${item?.alpha2_code.toLowerCase()}.webp`,
                                    alt: "Inboxino"
                                  }, null, 8, _hoisted_12)
                                ]),
                                _createElementVNode("div", _hoisted_13, _toDisplayString(item.alpha2_code), 1),
                                _createElementVNode("div", _hoisted_14, _toDisplayString(item.phone_code), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["label", "value", "selected"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("span", _hoisted_15, [
                      (_ctx.selectedLan)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "rounded-1",
                            src: `https://flagcdn.com/w40/${_ctx.selectedLan?.alpha2_code.toLowerCase()}.webp`,
                            alt: "Inboxino"
                          }, null, 8, _hoisted_16))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate("new password")), 1),
              _hoisted_19
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate("Continuation")), 1),
                _createElementVNode("span", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                  _hoisted_24
                ])
              ], 512),
              _createVNode(_component_router_link, {
                to: "/sign-up",
                class: "btn btn-lg btn-light-primary fw-bolder"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("cancel")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : (_openBlock(), _createBlock(_component_Form, {
          key: 1,
          class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
          onSubmit: _ctx.resetPassword,
          id: "kt_login_password_reset_form_2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.translate(
                  "Enter the verification code we sent to Whatsapp and SMS"
                )), 1),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formData.mobile), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.translate("Type your 4 digit security code")), 1),
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      onKeyup: _cache[2] || (_cache[2] = ($event: any) => ($event.target.nextElementSibling.focus())),
                      name: "code_1",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.codes.code_1) = $event)),
                      "data-inputmask": "'mask': '9', 'placeholder': ''",
                      placeholder: "-",
                      maxlength: "1",
                      autocomplete: "off",
                      class: "form-control bg-transparent h-40px w-40px fs-2 text-center mx-1 my-1"
                    }, null, 544), [
                      [_vModelText, _ctx.codes.code_1]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      onKeyup: _cache[4] || (_cache[4] = ($event: any) => ($event.target.nextElementSibling.focus())),
                      name: "code_2",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.codes.code_2) = $event)),
                      "data-inputmask": "'mask': '9', 'placeholder': ''",
                      placeholder: "-",
                      maxlength: "1",
                      autocomplete: "off",
                      class: "form-control bg-transparent h-40px w-40px fs-2 text-center mx-1 my-1"
                    }, null, 544), [
                      [_vModelText, _ctx.codes.code_2]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      onKeyup: _cache[6] || (_cache[6] = ($event: any) => ($event.target.nextElementSibling.focus())),
                      name: "code_3",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.codes.code_3) = $event)),
                      "data-inputmask": "'mask': '9', 'placeholder': ''",
                      placeholder: "-",
                      maxlength: "1",
                      autocomplete: "off",
                      class: "form-control bg-transparent h-40px w-40px fs-2 text-center mx-1 my-1"
                    }, null, 544), [
                      [_vModelText, _ctx.codes.code_3]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "code_4",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.codes.code_4) = $event)),
                      "data-inputmask": "'mask': '9', 'placeholder': ''",
                      placeholder: "-",
                      maxlength: "1",
                      autocomplete: "off",
                      class: "form-control bg-transparent h-40px w-40px fs-2 text-center mx-1 my-1"
                    }, null, 512), [
                      [_vModelText, _ctx.codes.code_4]
                    ]),
                    _createVNode(_component_SendActivationCode, {
                      source: _ctx.formData.mobile
                    }, null, 8, ["source"]),
                    _createVNode(_component_Field, {
                      type: "hidden",
                      autocomplete: "off",
                      class: "form-control bg-transparent d-none",
                      style: {"direction":"ltr"},
                      name: "code",
                      modelValue: _ctx.code,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.code) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_Field, {
                      class: "form-control form-control-lg form-control-solid d-none",
                      type: "hidden",
                      name: "mobile",
                      value: _ctx.formData.mobile
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", _hoisted_33, [
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.translate("Continuation")), 1),
                _createElementVNode("span", _hoisted_35, [
                  _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                  _hoisted_36
                ])
              ], 512),
              _createVNode(_component_router_link, {
                to: "/sign-up",
                class: "btn btn-lg btn-light-primary fw-bolder"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("cancel")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
  ]))
}